import { useMemo } from 'react';

import { Settings } from 'utils/constants/dynamicSettings';

import useSettings from 'hooks/useSettings';

import { selectQuickCampaignProfRoles } from 'store/models/createQuickCampaign';
import { useSelector } from 'store/utils';

export const useShowAiImageGeneration = (isQuickCampaign = false): boolean => {
    const settings = useSettings();

    const quickCampaignProfRoles = useSelector(selectQuickCampaignProfRoles);
    const adProfessions = useSelector((state) => state.createCampaign.adProfessions);

    const profRoles = isQuickCampaign ? quickCampaignProfRoles : adProfessions;

    const aiGenerationProfrolesBlacklist = settings(Settings.AiGenerationProfrolesBlacklist) as string[];
    const isAiImageGenerationEnabled = settings(Settings.AiImageGenerationEnabled) as boolean;

    const isProfRolesInBlacklist = useMemo(
        () =>
            profRoles.some(
                (profRole) => isAiImageGenerationEnabled && aiGenerationProfrolesBlacklist.includes(profRole)
            ),
        [profRoles, aiGenerationProfrolesBlacklist, isAiImageGenerationEnabled]
    );

    return isAiImageGenerationEnabled && !isProfRolesInBlacklist;
};
